import { useEffect } from "react";
import { useAuth } from "@/contexts/auth";
import { useNavigate, useLocation } from "react-router-dom";

const ApprovalStatusChecker = ({ children }: { children: React.ReactNode }) => {
  const { user, profile, isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Don't check if still loading or on public pages
    if (isLoading || !user || !profile) return;
    
    // Allow access to login, register, pending-approval, and home pages
    const publicPaths = ['/', '/login', '/register', '/auth/login', '/auth/register', '/pending-approval'];
    const isPublicPath = publicPaths.includes(location.pathname);
    
    if (isPublicPath) return;
    
    // Check approval status
    if (profile.approval_status === 'pending') {
      navigate('/pending-approval', { replace: true });
    } else if (profile.approval_status === 'rejected') {
      // Rejected users should be signed out and redirected to login
      navigate('/login', { replace: true });
    }
    // If approved, allow normal access
  }, [user, profile, isLoading, navigate, location.pathname]);

  return <>{children}</>;
};

export default ApprovalStatusChecker;